import styled from 'styled-components';

export const WrapperNaming = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    overflow-y: scroll;

    @media (max-width: 1200px) {
        padding: 0 16px;
        padding-bottom: 300px;
        width: 100%;
    }
`;

export const HeaderPage = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 16px 0;

    @media (max-width: 1200px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const TitlePage = styled.h1`
    font-family: MADE Outer Sans;
    font-size: 20px;
    font-weight: 700;
    line-height: 28px;
    text-align: left;
    font-family: MADE TOMMY;
    padding: 0;
    margin: 0;

    @media (max-width: 1200px) {
        font-size: 18px;
    }
`;

export const RemainingTickets = styled.h2`
    padding: 0;
    margin: 0;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.8px;
    letter-spacing: 0.016em;
    text-align: left;
    color: ${({ theme }) => theme.colors.button.text.disabled};
`;
